module.exports = __webpack_public_path__ + "img/intro-nube.53062735.png";